import React from 'react';
import UserFeedbackCard from './UserFeedbackCard';

// Map of card_id to custom card component
export const customCards: Record<string, React.ComponentType<any>> = {
  user_feedback: UserFeedbackCard,
  // Add more custom cards here as needed
  // 'other_card_id': OtherCardComponent,
};

// Helper function to get custom card component by card_id
export const getCustomCard = (
  cardId: string
): React.ComponentType<any> | undefined => {
  return customCards[cardId];
};

// Export individual components
export { UserFeedbackCard };
